import { useNavigate } from "react-router-dom";

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export default function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Top bar */}
      <header className="bg-faro-navy py-4 px-6 sticky top-0 z-50 shadow-sm">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/73dfd2d3-6ecc-4d20-afd5-49901dbfd111.png"
              alt="Faro Energía"
              className="h-12 w-auto object-contain brightness-0 invert"
            />
          </a>
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-base" />
            Volver a la web
          </button>
        </div>
      </header>

      {/* Hero strip */}
      <div className="bg-faro-teal-pale border-b border-faro-gray-mid">
        <div className="max-w-4xl mx-auto px-6 py-10">
          <h1 className="text-3xl md:text-4xl font-bold text-faro-navy mb-2">{title}</h1>
          <p className="text-faro-gray-text text-sm">Última actualización: {lastUpdated}</p>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-14">
        <div className="prose-legal">{children}</div>
      </main>

      {/* Footer mini */}
      <footer className="bg-faro-gray border-t border-faro-gray-mid py-6 px-6">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-faro-gray-text text-xs">
            &copy; {new Date().getFullYear()} Faro Energía · faroenergia.es · Todos los derechos reservados
          </p>
          <nav className="flex items-center gap-4">
            <a href="/aviso-legal" className="text-faro-gray-text hover:text-faro-teal text-xs transition-colors">Aviso legal</a>
            <a href="/politica-de-privacidad" className="text-faro-gray-text hover:text-faro-teal text-xs transition-colors">Privacidad</a>
            <a href="/politica-de-cookies" className="text-faro-gray-text hover:text-faro-teal text-xs transition-colors">Cookies</a>
          </nav>
        </div>
      </footer>
    </div>
  );
}
